import * as operations from './operations';
import * as types from './action-types';
import * as plaidTypes from '../components/Plaid/ducks/action-types';

const customerRequestState = {
  requestDocuments: [],
  request: {},
  requests: [],
  toastMessage: null,
  linkedPlaid: false,
  validationPassed: false,
  error: null,
  plaidAchMismatch: null,
  isLoading: false,
  orderOptions: [],
  loadingMessage: null,
  plaidError: null,
  completedAllRequests: false
};

export default function reducer(state = customerRequestState, action) {
  const { type, payload } = action;

  switch (type) {
    case `${types.CUSTOMER_REQUEST_DOCUMENT_SELECTED}`: {
      const requestDocuments = operations.SetRequestDocumentProps(
        state,
        payload
      );

      return {
        ...state,
        requestDocuments
      };
    }

    case `${types.CUSTOMER_VERIFIED_DOCUMENT}`: {
      payload.upload = true;
      payload.status = 'Attached';
      const requestDocuments = operations.SetRequestDocumentProps(
        state,
        payload,
        true
      );

      return {
        ...state,
        requestDocuments
      };
    }

    case `${types.FETCH_CUSTOMER_REQUEST_DOCUMENTS}_LOADING`:
      return {
        ...state,
        error: null,
        isLoading: true,
        requests: []
      };

    case `${types.FETCH_CUSTOMER_REQUEST_DOCUMENTS}_SUCCESS`: {
      return {
        ...state,
        isLoading: false,
        error: null,
        requests: payload
      };
    }

    case `${types.VERIFICATIONS_FETCH}_LOADING`:
      return {
        ...state,
        error: null,
        isLoading: true
      };

    case `${types.VERIFICATIONS_FETCH}_SUCCESS`: {
      return {
        ...state,
        isLoading: false,
        error: null
      };
    }

    case `${types.COMPLETE_CUSTOMER_REQUEST}_ERROR`: {
      return {
        ...state,
        isLoading: false,
        error: 'Error completing your request'
      };
    }

    case `${types.COMPLETING_CUSTOMER_REQUEST}_LOADING`:
      return {
        ...state,
        error: null,
        isLoading: true
      };

    case `${types.COMPLETING_CUSTOMER_REQUEST}_SUCCESS`: {
      return {
        ...state,
        error: null,
        isLoading: false
      };
    }

    case `${types.COMPLETE_ALL_PLAID_CUSTOMER_REQUESTS}_ERROR`: {
      return {
        ...state,
        isLoading: false,
        error: 'Error completing your request'
      };
    }

    case `${types.COMPLETE_ALL_PLAID_CUSTOMER_REQUESTS}_LOADING`:
      return {
        ...state,
        error: null,
        isLoading: true
      };

    case `${types.COMPLETE_ALL_PLAID_CUSTOMER_REQUESTS}_SUCCESS`: {
      return {
        ...state,
        error: null,
        isLoading: false,
        plaidError: false,
        completedAllRequests: true
      };
    }

    case `${types.COMPLETING_CUSTOMER_REQUEST}_ERROR`: {
      return {
        ...state,
        isLoading: false,
        error: 'Error completing your request',
        plaidError: true
      };
    }
    case `${plaidTypes.OPEN_PLAID}_LOADING`: {
      return {
        ...state,
        loadingMessage: 'Working on Loading Plaid',
        plaidError: false
      };
    }

    case `${plaidTypes.OPEN_PLAID}_SUCCESS`: {
      return {
        ...state,
        loadingMessage: 'Still working, this may take up to 30 seconds',
      };
    }

    case `${plaidTypes.OPEN_PLAID}_ERROR`: {
      return {
        ...state,
        linkedPlaid: false,
        loadingMessage: null,
        plaidError: true
      };
    }

    case `${plaidTypes.OPEN_AND_SAVE_PLAID}_ERROR`: {
      return {
        ...state,
        linkedPlaid: false,
        loadingMessage: null,
      };
    }

    case `${plaidTypes.SAVE_PLAID_LINK}_LOADING`: {
      return {
        ...state,
        loadingMessage: 'Still working, this may take up to 30 seconds',
        plaidError: false
      };
    }

    case `${plaidTypes.SAVE_PLAID_LINK}_ERROR`: {
      return {
        ...state,
        linkedPlaid: false,
        loadingMessage: null,
        error: action.payload.errorMsg,
        plaidAchMismatch: action.payload.plaidAchMismatch,
        plaidError: true
      };
    }

    case `${plaidTypes.SAVE_PLAID_SUBSCRIPTION}_LOADING`: {
      return {
        ...state,
        loadingMessage: 'Still working, this may take up to 30 seconds',
        plaidError: false
      };
    }

    case `${plaidTypes.SAVE_PLAID_SUBSCRIPTION}_ERROR`: {
      return {
        ...state,
        linkedPlaid: false,
        loadingMessage: null,
        error: 'Error saving Plaid subscription',
        plaidError: true
      };
    }

    case `${plaidTypes.SAVE_PLAID_SUBSCRIPTION}_SUCCESS`: {
      return {
        ...state,
        loadingMessage: null,
        linkedPlaid: true
      };
    }

    case `${plaidTypes.RESET_PLAID}`: {
      return {
        ...state,
        loadingMessage: null,
        linkedPlaid: false,
        plaidError: null
      }
    }

    case `${plaidTypes.REFRESH_PLAID_BALANCE}_LOADING`: {
      return {
        ...state,
        isLoading: true
      };
    }

    case `${plaidTypes.REFRESH_PLAID_BALANCE}_ERROR`: {
      return {
        ...state,
        isLoading: false
      };
    }

    case `${plaidTypes.REFRESH_PLAID_BALANCE}_SUCCESS`: {
      return {
        ...state,
        isLoading: false,
        linkedPlaid: true
      };
    }

    case `${types.PASSED_VALIDATION}`: {
      return {
        ...state,
        validationPassed: true
      };
    }

    case `${types.REQUEST_DOCUMENT_CHANGED}`: {
      const requestDocuments = operations.UpdateRequestDocument(state, payload);

      return {
        ...state,
        requestDocuments
      };
    }

    case `${types.RESET_CUSTOMER_REQUEST}`:
      return {
        ...customerRequestState,
        requests: state.requests
      };

    case `${types.SELECTED_CUSTOMER_REQUEST}`: {
      const requestDocuments = operations.SetRequestDocuments(state, payload);

      return {
        ...state,
        request: payload,
        requestDocuments
      };
    }

    case `${types.UPLOADING_REQUEST_DOCUMENTS}_ERROR`: {
      return {
        ...state,
        isLoading: false,
        error: 'Error while uploading you request document(s)'
      };
    }

    default:
      return state;
  }
}
